import React, { Component } from 'react';
import {Paper, Grid, Typography, Button} from '@material-ui/core';
import * as Gserv from '../services/GatewayService';
// import Settings from '@material-ui/icons/Settings';
import DatasheetView from './DatasheetView';
// import Toggle from './Toggle';
import * as Calc from '../services/CalcService';

export default class CyclesArchiving extends Component {

    constructor(props) {
        super(props);
        this.reset_state = { 
            can_submit: true,
            writing: false,
            error: false,
            error_message: '',
            querying: true,
            cycles_array: [],
            selected_cycles: [],
            show_archives: false,
            show_open: true,
            show_closed: false,
            show_dialogue: false,
        };
        this.state = this.reset_state;
    
        this.datasheetFieldSpecs = [
            { field: 'job_title', headerName: 'For Designation', width: 160},
            { field: 'cycle_name', headerName: 'Cycle Description', width: 160, sortable:false},
            { field: 'cycle_code', headerName: 'Short Code', width: 130},
            { field: 'open_date', headerName: 'Open From', width: 130},
            { field: 'deadline_date', headerName: 'Deadline', width: 130},
            { field: 'employed_from', headerName: 'DOE Cutoff', width: 130, sortable:false},
            { field: 'closed', headerName: 'Closed?', width: 90, sortable:false, align: 'center'},
            { field: 'archived', headerName: 'Archived?', width: 100, sortable:false, align: 'center'},
        ]
    }

    componentDidMount = () => {

        //async get latest assessment / cycle matrix...
        Gserv.sendCommand('query_open_cycles',this.props.gwt)
        .then(reply=>{
            // console.log('query_open_cycles reply :>> ', reply);
            if (reply.error){
                console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
            } else {
                //clean formats for display
                if (reply.Records){
                let cycle_array = reply.Records;
                    let open_date = null;
                    let deadline_date = null;
                    let employed_from = null;
                    for (var i=0;i<cycle_array.length;i++){
                        open_date = new Date(cycle_array[i].open_date);
                        deadline_date = new Date(cycle_array[i].deadline_date);
                        employed_from = new Date(cycle_array[i].employed_from);
                        cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                        cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                        cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                        cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                        cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                    }
                }
                this.setState({querying:false, cycles_array:reply.Records?reply.Records : []});
            }
        });
    };

    refreshCycleList = (set) => {
       //async get latest assessment / cycle matrix (either open,closed or archived cycles)...
       if (set==='open'){
            Gserv.sendCommand('query_open_cycles',this.props.gwt)
            .then(reply=>{
                // console.log('query_open_cycles reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_open_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    
                    //clean formats for display
                    if (reply.Records){
                    let cycle_array = reply.Records;
                        let open_date = null;
                        let deadline_date = null;
                        let employed_from = null;
                        for (var i=0;i<cycle_array.length;i++){
                            open_date = new Date(cycle_array[i].open_date);
                            deadline_date = new Date(cycle_array[i].deadline_date);
                            employed_from = new Date(cycle_array[i].employed_from);
                            cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                            cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                            cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                            cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                            cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                        }
                    }
                    this.setState({querying:false, cycles_array:reply.Records?reply.Records : []});
                }
            });
        } else if (set==='closed'){
            Gserv.sendCommand('query_closed_cycles',this.props.gwt)
            .then(reply=>{
                // console.log('query_closed_cycles reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_closed_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_closed_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    
                    //clean formats for display
                    if (reply.Records){
                    let cycle_array = reply.Records;
                        let open_date = null;
                        let deadline_date = null;
                        let employed_from = null;
                        for (var i=0;i<cycle_array.length;i++){
                            open_date = new Date(cycle_array[i].open_date);
                            deadline_date = new Date(cycle_array[i].deadline_date);
                            employed_from = new Date(cycle_array[i].employed_from);
                            cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                            cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                            cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                            cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                            cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                        }
                    }
                    this.setState({querying:false, cycles_array:reply.Records?reply.Records : []});
                }
            });
        } else if (set==='archives') {
            Gserv.sendCommand('query_archived_cycles',this.props.gwt)
            .then(reply=>{
                // console.log('query_archived_cycles reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (query_archived_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.Result!=="Success"&&reply.statusCode!==204){
                    console.log('error on return from Gserv (query_archived_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    
                    //clean formats for display
                    if (reply.Records){
                    let cycle_array = reply.Records;
                        let open_date = null;
                        let deadline_date = null;
                        let employed_from = null;
                        for (var i=0;i<cycle_array.length;i++){
                            open_date = new Date(cycle_array[i].open_date);
                            deadline_date = new Date(cycle_array[i].deadline_date);
                            employed_from = new Date(cycle_array[i].employed_from);
                            cycle_array[i].open_date = open_date.getFullYear() + "-" +  Calc.twoDigit((open_date.getMonth()+1)) + "-" + Calc.twoDigit(open_date.getDate());;
                            cycle_array[i].deadline_date = deadline_date.getFullYear() + "-" +  Calc.twoDigit((deadline_date.getMonth()+1)) + "-" + Calc.twoDigit(deadline_date.getDate());;
                            cycle_array[i].employed_from = employed_from.getFullYear() + "-" +  Calc.twoDigit((employed_from.getMonth()+1)) + "-" + Calc.twoDigit(employed_from.getDate());
                            cycle_array[i].closed = cycle_array[i].closed? "YES" : "";
                            cycle_array[i].archived = cycle_array[i].archived? "YES" : "";
                        }
                    }
                    this.setState({querying:false, cycles_array:reply.Records?reply.Records : []});
                }
            });
        }        
    }

    processSelection = (op) => {
        // console.log('called op :>> ', op);

        if (this.state.selected_cycles.length>0){

            this.setState({writing:true});

            Gserv.sendCommand('update_bulk_cycles',this.props.gwt,{
                selected_cycles : this.state.selected_cycles,
                op : op
            })
            .then(reply => {
                // console.log('create reply :>> ', reply);
                if (reply.error){
                    console.log('error on return from Gserv (update_bulk_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else if (reply.statusCode===409){
                    console.log('error on return from Gserv (update_bulk_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A cycle with this code or name already exists.",querying:false});
                } else if (reply.Result!=="Success"){
                    console.log('error on return from Gserv (update_bulk_cycles) :>> ', reply);
                    this.setState({error:true,error_message:"A technical error has been encountered, and we're not able to process this request at the moment. If this problem persists, please contact us.",querying:false});
                } else {
                    this.setState(this.reset_state);
                    this.refreshCycleList('open');
                }
            });
        }
    }
  
    resetMe = () => {
        this.setState(this.reset_state);
        this.componentDidMount();
    }

    handleSelectionChange = (selection_array) => {
        this.setState({selected_cycles:selection_array});
    }

    handleButt = (e) => {
        console.log('e :>> ', e);
        switch (e) {
            case 'open':
                this.setState({show_open:true,show_closed:false,show_archives:false,selected_cycles:[], querying:true});
                this.refreshCycleList('open');
            break;
            case 'closed':
                this.setState({show_closed:true,show_open:false,show_archives:false,selected_cycles:[], querying:true});
                this.refreshCycleList('closed');
            break;
            case 'archives':
                this.setState({show_archives:true,show_closed:false,show_open:false,selected_cycles:[], querying:true});
                this.refreshCycleList('archives');
            break;
        
            default:
            break;
        }
    }

    render() {
        return (
            <Grid
                container
                direction='column'
                justifyContent='center'
                alignContent='center'
                // style={{backgroundColor:'yellow'}}
            >
                <Grid item>
                <Paper
                    elevation={3}
                    style={{
                        // backgroundColor:'yellow',
                        // height:'22vh',
                        // maxWidth:680,
                        // minWidth:680
                        width:1155
                    }}
                >
                   <Typography
                    color='primary'
                    style={{paddingTop:15}}
                   >
                       Closing and Archiving of Assessment Cycles
                   </Typography>

                    <Grid
                        container 
                        direction='row'
                        justifyContent='center'
                        alignContent='center'
                        style={{borderStyle:'solid',borderWidth:1,marginTop:10,marginBottom:5}}
                    >
                        
                        <Button
                            id='open'
                            variant='outlined'
                            color='primary'
                            disabled={this.state.show_open}
                            onClick={() => this.handleButt('open')}
                        >
                            VIEW OPEN CYCLES
                        </Button>
                        <Button
                            id='closed'
                            variant='outlined'
                            color='primary'
                            disabled={this.state.show_closed}
                            onClick={() => this.handleButt('closed')}
                        >
                            VIEW CLOSED CYCLES
                        </Button>
                        <Button
                            id='archives'
                            variant='outlined'
                            color='primary'
                            disabled={this.state.show_archives}
                            onClick={() => this.handleButt('archives')}
                        >
                            VIEW ARCHIVED CYCLES
                        </Button>


                        {/* <Toggle 
                            fieldMap={{field: "show_archives", headerName: "View Archived Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}}
                            setField={this.handleToggleChange}
                        /> */}
                        {/* <Toggle
                            fieldMap={{field: "show_all", headerName: "Show Closed Cycles?", f_inputType:'toggle', f_true_tag:'Yes', f_false_tag:'No', f_show:true}} 
                            editRecord={{show_all: this.state.show_all}}
                            setField={this.handleToggleChange}
                        /> */}

                    </Grid>
                   
                   <Grid
                    container
                    direction='row'
                    justifyContent='space-evenly'
                    alignContent='center'
                    style={{padding:15}}
                   >

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.processSelection('close')}
                        disabled={this.state.show_archives||(this.state.selected_cycles.length<1)||this.state.writing}
                    >
                        CLOSE SELECTED CYCLES
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.processSelection('open')}
                        disabled={this.state.show_archives||(this.state.selected_cycles.length<1)||this.state.writing}
                    >
                        OPEN SELECTED CYCLES
                    </Button>
                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.processSelection('archive')}
                        disabled={this.state.show_archives||(this.state.selected_cycles.length<1)||this.state.writing}
                    >
                        ARCHIVE SELECTED CYCLES
                    </Button>

                    <Button
                        variant='contained'
                        color='primary'
                        type='submit'
                        onClick={()=>this.processSelection('unarchive')}
                        disabled={!this.state.show_archives||(this.state.selected_cycles.length<1)||this.state.writing}
                    >
                        DE-ARCHIVE SELECTED CYCLES
                    </Button>

                   </Grid>
                </Paper>
                </Grid>

                <Grid item>
                    <Typography color='secondary' style={{Width:1155,maxWidth:1155, textAlign:'center'}}>{this.state.error_message}</Typography>
                    {this.state.error&&<Button color='primary' variant='outlined' onClick={this.resetMe}>Reset</Button>}
                </Grid>

                {/* Datagrid goes here */}
                <DatasheetView 
                    dataset={this.state.cycles_array}
                    fieldspecs={this.datasheetFieldSpecs}
                    delete={false}
                    edit={false}
                    handleDelete={null}
                    handleEdit={null}
                    loading={this.state.querying||this.state.writing}
                    deleteHeaderName={''}
                    pagesize={8}
                    checkboxSelection={true}
                    handleSelectionChange={this.handleSelectionChange}
                />

            </Grid>
        );
    }
    
}